import candidateReducer from './candidate'
import interviewRequestReducer from './interviewRequest'
import notesReducer from './notes'
import positionsReducer from './positions'
import competingInterviewRequestsReducer from './competingInterviewRequests'
import accountManagerReducer from './accountManager'

import * as candidateModule from './candidate'
import * as interviewRequestModule from './interviewRequest'
import * as notesModule from './notes'
import * as positionsModule from './positions'
import * as competingInterviewRequestsModule from './competingInterviewRequests'
import * as accountManagerModule from './accountManager'

export { candidateModule, interviewRequestModule, notesModule, positionsModule, competingInterviewRequestsModule, accountManagerModule }

export default {
  candidate: candidateReducer,
  interviewRequest: interviewRequestReducer,
  notes: notesReducer,
  positions: positionsReducer,
  competingInterviewRequests: competingInterviewRequestsReducer,
  accountManager: accountManagerReducer,
}
